// extracted by mini-css-extract-plugin
export default {"Location":"Location_Location__iX2be"};